






import { Vue, Component, PropSync } from 'vue-property-decorator';
import Tab2Condition from './rule-form-tab2-condition.vue';
import Tab2Action from './rule-form-tab2-action.vue';
import { RuleDto } from '@/services/rule';

@Component({
  components: { Tab2Condition, Tab2Action }
})
export default class RuleFormTab2 extends Vue {
  @PropSync('formData') syncFormData!: RuleDto;
  entity: any = { type: '0', list: [] };

  created() {}
}
